import * as React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { removeAllFilters } from '../redux-state/actions/filters';

interface DispactToProps {
    removeAll: () => void
}

export interface IExternalProps {
    text: string;
}

type ClearProps = IExternalProps & DispactToProps;

export class ClearAll extends React.Component<ClearProps, null> {

    private clearAll() {

        this.props.removeAll();
    }
    private boundClearAll = this.clearAll.bind(this);

    render() {
        return (
            <button className="btn-text" type="button" onClick={this.boundClearAll}>{this.props.text}</button>
        )
    }
}

export function mapDispatchToProps(dispatch: Dispatch): DispactToProps {
    return {
        removeAll: () => { dispatch(removeAllFilters()) }
    }

}

export const ConnectedClearAll = connect(null, mapDispatchToProps)(ClearAll);